export const STYLE = `mapbox://styles/latimes/cmurcmb6g008u01r7840o1hoz${
  process.env.NODE_ENV === 'development' ? '/draft' : ''
}`;

export const TOKEN =
  'pk.eyJ1IjoibGF0aW1lcyIsImEiOiJjajhvcXRraGUwNnlwMzNyczR3cTBsaWh1In0.0cPKLwe2A0ET4P5CtWSiLQ';

// max zoom after geocoding
export const GEOCODER_ZOOM = 13;

export const GEOGRAPHIES = {
  city: {
    // Which precincts to show (matches the tileset's properties)
    FILTER: ['==', ['get', 'city'], 'Los Angeles'],
    // City of Los Angeles bounding box [[west, south], [east, north]]
    BOUNDS: [
      [-118.6682, 33.7036],
      [-118.1553, 34.3373],
    ],
    // Slightly looser than LA_BOUNDS so the city isn't clipped on load
    MAX_BOUNDS: [
      [-118.75, 33.65],
      [-118.1, 34.4],
    ],
    MIN_ZOOM: 9.75,
    MAX_ZOOM: 13,
  },
  county: {
    // null = show every precinct in the tileset
    FILTER: null,
    BOUNDS: [
      [-118.996113102026257, 33.647665369800599],
      [-117.5775454238293065, 34.9107262379637788],
    ],
    MAX_BOUNDS: [
      [-118.996113102026257, 33.647665369800599],
      [-117.5775454238293065, 34.9107262379637788],
    ],
    MIN_ZOOM: 6,
    MAX_ZOOM: 13,
  },
  district3: {
    FILTER: ['==', ['get', 'district'], '3'],
    BOUNDS: [
      [-118.6682, 34.1258],
      [-118.5272, 34.2355],
    ],
    MAX_BOUNDS: [
      [-118.6682, 34.1258],
      [-118.5272, 34.2355],
    ],
    MIN_ZOOM: 6,
    MAX_ZOOM: 13,
  },
  district4: {
    FILTER: ['==', ['get', 'district'], '4'],
    BOUNDS: [
      [-118.5492, 34.091],
      [-118.2559, 34.221],
    ],
    MAX_BOUNDS: [
      [-118.5492, 34.091],
      [-118.2559, 34.221],
    ],
    MIN_ZOOM: 6,
    MAX_ZOOM: 13,
  },
  district9: {
    FILTER: ['==', ['get', 'district'], '9'],
    BOUNDS: [
      [-118.3003, 33.9502],
      [-118.2379, 34.0467],
    ],
    MAX_BOUNDS: [
      [-118.3003, 33.9502],
      [-118.2379, 34.0467],
    ],
    MIN_ZOOM: 6,
    MAX_ZOOM: 13,
  },
};

export const MAP_COLORS = { tie: 'rgb(53, 80, 89)', noData: 'rgba(0,0,0,0)' };

// export const TILESET = 'mapbox://latimes.8evojb'; // first drop
export const TILESET = 'mapbox://latimes.ozu2pp';
export const SOURCE = '2026precincts';
export const SOURCE_LAYER = 'precincts';
